import EditIcon from "@mui/icons-material/EditOutlined";
import { IconButton, Tooltip } from "@mui/material";
import type { GridCellParams, GridColDef } from "@mui/x-data-grid-premium";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { ObjectAccessCategory } from "../../../../api/types/objectTypes";
import DataRequestSetupPageContext from "../data-request-templates/DataRequestSetupPageContext";
import { formatRecipientCategoryType } from "./objectCategoriesFormatter";

const RecipientTypeCell = ({ row }: { row: ObjectAccessCategory }) => {
  const { objectDefinition } = useDefinedContext(DataRequestSetupPageContext);
  return <>{formatRecipientCategoryType(row.type, objectDefinition)}</>;
};

const ActionsCell = () => {
  const { hasPermissionsToManage } = useDefinedContext(DataRequestSetupPageContext);

  if (!hasPermissionsToManage) {
    return null;
  }

  return (
    <>
      <Tooltip title="Edit" arrow>
        <IconButton>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

const columnDefinitions: GridColDef<ObjectAccessCategory>[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "type",
    headerName: "Recipient Type",
    flex: 1,
    renderCell: ({ row }) => <RecipientTypeCell row={row} />,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 72,
    align: "right",
    headerAlign: "right",
    cellClassName: "grid-row-actions",
    renderCell: () => <ActionsCell />,
  },
];

interface Props {
  onCategoryEdit: (categoryId: string) => void;
}

const DataRequestCategoriesGrid = ({ onCategoryEdit }: Props) => {
  const { categories } = useDefinedContext(DataRequestSetupPageContext);

  const handleCellClick = ({ field, row }: GridCellParams<ObjectAccessCategory>) => {
    if (field === "actions") {
      onCategoryEdit(row.id);
    }
  };

  return (
    <DataGrid<ObjectAccessCategory>
      rows={categories}
      columns={columnDefinitions}
      noRowsText="No categories"
      onCellClick={handleCellClick}
      disableColumnReorder
      disableColumnSorting
    />
  );
};

export default DataRequestCategoriesGrid;
